import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/authentication/services/authentication.service';
import { ContainerCard } from 'src/app/card/model/card-implementations/container-card';
import {
    Container,
    ContainerPage,
} from 'src/app/shared/models/container.types';
import { BaseLibraryComponent } from '../base-library/base-library.component';
import { ContainerService } from 'src/app/shared/services/container/container.service';

@Component({
    selector: 'app-container-library',
    templateUrl: './container-library.component.html',
    styleUrls: ['./container-library.component.scss'],
    standalone: false,
})
export class ContainerLibraryComponent extends BaseLibraryComponent {
    constructor(
        private containerService: ContainerService,
        protected route: ActivatedRoute,
        protected authenticationService: AuthenticationService,
        protected router: Router
    ) {
        super(authenticationService, route, router);
    }

    convertToCard(container: Container, picture: string) {
        return ContainerCard.convertToCard(
            container,
            picture,
            container.membershipStatus !== 'OWNER'
        );
    }

    getData(): Observable<ContainerPage> {
        return this.containerService.getAllUserContainers(
            this.types,
            this.cardPage.pageable
        );
    }
}
